import { toNumber } from '@rahtab/system/lib/tools/string';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetCorrectionRemainingHistoryProps } from 'hooks/InventoryHooks/useLoadRevisionList';
import type { LoadFullInfo, ServerFullInfo, loadReducer } from '../../hooks/InventoryHooks/useLoadsList';

const initialState: LoadsSliceState = {
  loading: 'idle',
  loads: {},
};

export const loadsSlice = createSlice({
  name: 'loads',
  initialState,
  reducers: {
    loadsLoading: (state, { payload }: PayloadAction<LoadsSliceState['loading']>) => {
      state.loading = payload;
    },
    addLoads: (state, action: PayloadAction<ServerFullInfo[]>) => {
      action.payload.forEach((serverLoad) => {
        const {
          AssignFinallCode: assignFinallCode,
          AFIdentification: afIdentification,
          LoadName: loadName,
          RegulationTag: regulationTag,
          TemplateName: templateName,
          MiddlemanName: middlemanName,
          Amount: amount,
          MeasureCode: measureCode,
          MeasureName: measureName,
          PricePerUnit: pricePerUnit,
          TotalPrice: totalPrice,
          StatusCode: statusCode,
          Status: status,
          AssignDate: assignDate,
          DeliveryDate: deliveryDate,
          ReceiveDate: receiveDate,
          SaleAmount: saleAmount,
          RemainingValue: remainingValue,
          CorrectionAmount: correctionAmount,
          ReturnAmount: returnAmount,
          SalePercent: salePercent,
          RemainingPercent: remainingPercent,
          CorrectionPercent: correctionPercent,
          ReturnPercent: returnPercent,
          OriginalAmount: initialAmount,
          ReceivedAmount: receivedAmount,
          OriginalPricePerUnit: initialPricePerUnit,
        } = serverLoad;

        const load: LoadFullInfo = {
          assignFinallCode,
          afIdentification,
          loadName,
          regulationTag,
          templateName,
          middlemanName,
          amount,
          measureCode,
          measureName,
          pricePerUnit,
          totalPrice,
          statusCode,
          status,
          assignDate,
          deliveryDate,
          receiveDate,
          saleAmount: toNumber(saleAmount),
          remainingValue: toNumber(remainingValue),
          correctionAmount: toNumber(correctionAmount),
          returnAmount: toNumber(returnAmount),
          salePercent,
          remainingPercent,
          correctionPercent,
          returnPercent,
          initialAmount,
          receivedAmount,
          initialPricePerUnit,
        };
        state.loads[assignFinallCode] = { ...state.loads[assignFinallCode], ...load };
      });
    },
    setLoadCorrection(state, { payload }: PayloadAction<GetCorrectionRemainingHistoryProps & { id: string }>) {
      state.loads[payload.id].correctionsCount = toNumber(payload.CorrectionCount);
      state.loads[payload.id].conflictionAmount = toNumber(payload.ContradictionAmount);
      state.loads[payload.id].defectiveAmount = toNumber(payload.DefectiveAmount);
      state.loads[payload.id].outSaleAmount = toNumber(payload.OutNetSaleAmount);
      state.loads[payload.id].otherReasonAmount = toNumber(payload.OtherReasonAmount);
      state.loads[payload.id].unitText = payload.MeasureName;
      state.loads[payload.id].conflictionPercent = toNumber(payload.ContradictionPercent);
      state.loads[payload.id].defectivePrecent = toNumber(payload.DefectivePercent);
      state.loads[payload.id].outSalePercent = toNumber(payload.OutNetSalePercent);
      state.loads[payload.id].otherReasonPercent = toNumber(payload.OtherReasonPercent);
    },
  },
});

export const { loadsLoading, addLoads, setLoadCorrection } = loadsSlice.actions;

export default loadsSlice.reducer;

interface LoadsSliceState {
  loading: 'idle' | 'refreshing';
  loads: {
    [K: string]: LoadFullInfo;
  };
}
